export default {
  affiliate: {
    // Main navigation
    title: 'Ahli Gabungan',
    cantFindQuestion: 'Tidak dapat mencari soalan?',
    onlineService: 'Perkhidmatan Dalam Talian',
    dashboard: 'Papan Pemuka',
    myRewards: 'Ganjaran Saya',
    // My Price 页（照 Figma 重做）
    team: 'Team',
    myPrice: 'My Price',
    rule: 'Rule',
    checkOutRules: 'Check Out Our Rules',
    rewardsOverview: 'Rewards Overview',
    rewardAmount: 'Reward Amount',
    date: 'Date',
    selectDate: 'Select Date',
    commissionRewards: 'Commission Rewards',
    noReferralRewards: 'No referral rewards yet \nInvite friends to start earning rewards',
    noCommissionRewards: 'No commission rewards yet \nStart earning by inviting friends',
    inviteFriendsToEarnTitle: 'Invite Friends To Earn',
    moreFriendsMoreRewards: 'More friends, more rewards, unlimited earning potential !',
    inviteNow: 'Invite Now',
    invitationRewards: 'Ganjaran Jemputan',
    rules: 'Peraturan',

    // Team Info
    teamData: 'Data Pasukan',
    details: 'Butiran',
    totalValidFriends: 'Jumlah rakan sah:',
    todayTotalWager: 'Jumlah pertaruhan hari ini:',
    rewards: 'Ganjaran',

    // Commission rates
    inviteFriendsCommissionUpTo: 'Komisen Jemputan Rakan Sehingga',
    expandTeamBonus: 'Bonus Pengembangan Pasukan',
    maxLevelCommission: 'Komisen Tahap Maksimum',
    inviteFriendsCommission: 'Komisen Jemputan Rakan',
    maxPerformanceCommission: 'Komisen Prestasi Maksimum',
    unlimitedAgent: 'Ejen Tanpa Had',
    unlimitedCommission: 'Komisen Tanpa Had',
    commissionRate: 'Kadar Komisen',

    // Team Invite Friends
    inviteFriendsToEarn: 'JEMPUT RAKAN UNTUK MENDAPAT',
    link: 'Pautan',
    code: 'Kod',
    inviteFriends: 'Jemput rakan',
    share: 'Kongsi',

    // Withdrawal Rewards
    totalCommission: 'Total Commission',
    claim: 'Tuntut',
    bettingBonus: 'Betting Bonus',
    depositBonus: 'Deposit Bonus',
    todayReceived: 'Diterima Hari Ini',

    // Live Rewards
    liveRewards: 'Ganjaran Langsung',
    sendTotalCommission: 'Hantar jumlah komisen',

    // Team Data Details
    totalRewardsReceived: 'Total Commission',
    todayInviteFriends: 'Jemput Rakan Hari Ini',
    todayDepositFriends: 'Rakan Deposit Hari Ini',
    depositFriends: 'Rakan Deposit',
    validFriends: 'Rakan Sah',

    // Dialogs
    howMakeFriendsSubordinates: 'Cara menjadikan rakan sebagai subordinat anda:',
    shareInvitationLink: 'Kongsi pautan jemputan anda untuk mereka mendaftar.',
    shareInvitationCode: 'Kongsi kod jemputan anda untuk mereka masukkan semasa pendaftaran.',
    shareQRCode: 'Kongsi kod QR anda untuk mereka imbas dan daftar.',
    depositFriendsDescription: 'Apabila rakan subordinat anda berjaya mendepositkan wang, mereka akan menjadi rakan yang mendepositkan.',
    howMakeFriendsValidUsers: 'Cara menjadikan rakan anda pengguna sah:',
    successfullyInviteFriends: 'Berjaya menjemput rakan untuk mendaftar.',
    cumulativeDepositsReach: 'Deposit kumulatif mereka mencapai 10.00 USDT.',
    cumulativeValidBetsReach: 'Pertaruhan sah kumulatif mereka mencapai 50.00 USDT.',
    thenBecomeValidUsers: 'Kemudian, mereka akan menjadi pengguna sah.',

    // Share Dialog
    shareTitle: 'Kongsi',
    player: 'Pemain',
    saveImage: 'Simpan imej',
    saveImageSuccess: "Imej disimpan",
    saveImageFailed: "Gagal menyimpan, sila cuba lagi",
    copy: 'Salin',
    copied: 'Disalin!',

    // Received/Withdraw
    received: 'Diterima',
    withdraw: 'Keluarkan',
    history: 'Sejarah',
    referralRewards: 'Ganjaran Rujukan',
    commission: 'Komisen',
    depositRebate: 'Rebat Deposit',
    levelUpRewards: 'Ganjaran Naik Tahap',
    loading: 'Memuatkan...',
    noMoreRecords: 'Tiada lagi rekod',
    loadMore: 'Muat lebih banyak',
    pending: 'Belum selesai',
    paid: 'Dibayar',
    rejected: 'Ditolak',
    unknown: 'Tidak Diketahui',
    upgradeReward: 'Ganjaran Naik Tahap',
    cancelled: 'Dibatalkan',
    receiving: 'Sedang Diterima',
    failed: 'Gagal',
    expired: 'Tamat Tempoh',

    // History Dialog
    pickDate: 'Pilih tarikh',
    select: 'Pilih',
    chooseBonus: 'Pilih bonus',
    all: 'Semua',

    // Invitation Rewards Page
    inviteFriendToGet: 'Jemput rakan untuk mendapat',
    yourFriendGet: 'Rakan anda mendapat',
    inviteFriendsEarnRewards: 'Jemput rakan dan dapatkan ganjaran',
    dailyInvitations: 'Jemputan harian',

    // Rules - How to earn
    howToEarnAffiliateRewards: 'Bagaimana untuk mendapat ganjaran ahli gabungan?',
    shareToFriends: 'Kongsi kepada rakan',
    shareReferralLink: 'Kongsi pautan rujukan, kod atau kod QR anda dengan rakan-rakan anda',
    friendsSignUpDeposit: 'Rakan mendaftar dan mendepositkan',
    inviteFriendsRegisterDeposit: 'Jemput rakan untuk mendaftar di AFUN dan membuat deposit pertama.',
    getUpTo: 'Dapatkan sehingga',
    earnBigRewards: 'Dapatkan ganjaran & komisen apabila rakan bertaruh, mendepositkan, dan mencapai VIP.',
    noticeEnsureCorrect: 'Notis: Pastikan pautan jemputan, kod QR, atau kod adalah betul.',

    // Rules - Commission Work
    howCommissionWork: 'Bagaimana Komisen berfungsi?',
    agentRatingDescription: 'Penerangan Penarafan Ejen',
    you: 'ANDA',
    commissionDescription: 'Dapatkan komisen daripada deposit dan pertaruhan Rakan B, C, D, dan seterusnya. Lihat jadual di sebelah kanan untuk kadar komisen.',
    claimConditions: 'Syarat tuntutan',
    teamLevel: 'Tahap Pasukan',
    earnUpTo: "Earn up to",
    expandYourTeam: "Kembangkan Pasukan Anda",
    earnAnExtra: "Dapatkan Tambahan",
    upgradeAgentLevel: "Naik Taraf Tahap Ejen Anda",
    todayValidFriends: "Today valid friends",
    inviteFriendsAndEarn: "INVITE FRIENDS AND EARN",
    joinUsGetCommission: "Join us and get more commission",
    shareLinkInviteDesc: "Share the link with your friends and invite them to register and deposit, you and your friend can get shared commissions.",
    totalSize: 'Jumlah Saiz',
    teamWager: 'Pertaruhan Pasukan',
    rebateRewardVary: 'Ganjaran Rebat & Ganjaran Tambah Nilai berbeza berdasarkan tahap Pasukan anda pada hari itu.',
    teamSizeDescription: 'Saiz pasukan: Bilangan pengguna sah yang anda miliki pada masa ini.',
    teamBettingDescription: 'Pertaruhan pasukan: Jumlah pertaruhan yang dibuat oleh subordinat anda dalam satu hari.',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: 'KOMISEN PASUKAN',
    teamCommissionSubTitle: 'Dapatkan daripada setiap deposit dan\nsetiap pertaruhan dalam rangkaian anda.',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: 'Jemput rakan, dan kedua-duanya akan menerima ganjaran',
    inviteRegisterReceive: 'Berjaya menjemput rakan untuk mendaftar dan menerima',
    friendDepositWagerUnlock: 'Apabila rakan anda mendepositkan 10.00 USDT dan bertaruh 50.00 USDT, anda membuka kunci ganjaran 3.00 USDT, dan rakan anda mendapat 2.00 USDT.',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: 'Jemputan Rakan Terkini',
    recentDepositFriends: 'Rakan Deposit Terkini',
    today: 'Hari Ini',
    yesterday: 'Semalam',
    thisMonth: 'Bulan ini',
    friendsData: 'Data Rakan',
    joinDate: 'Tarikh Menyertai',
    search: 'Cari',
    level: 'Tahap',
    tier: 'Tingkat',
    affiliateTreasureBox: 'Kotak Harta Ahli Gabungan',
    referralRewardsDesc: 'Apabila anda menjemput rakan untuk mendaftar, anda dan rakan anda akan menerima bonus lumayan.',
    commissionDesc: 'Anda dan pasukan anda bekerjasama untuk mencapai matlamat dan memperoleh komisen lumayan.',
    affiliateTreasureBoxDesc: 'Jemput rakan untuk mendapatkan bonus pencapaian',
  }
};
